import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsNotEmpty, IsNumberString, IsOptional, IsString, Matches, MaxLength, ValidateNested } from "class-validator";
import { GlobalStatus } from "@gtpl/shared-models/common-models";

export class LabellingSamplesDTO {
    @ApiPropertyOptional()
    labellingSamplesId: number;

    @ApiProperty()
    labellingId: number;

    @ApiProperty()
    time: Date;

   

    @ApiProperty()
    shrimpsLabel: boolean;

    @ApiProperty()
    allergenLabel: boolean;

    @ApiProperty()
    certificationLogo: string;

    @ApiProperty()
    remarks: string;

    @ApiProperty()
    correctiveAction: string;

    @ApiProperty()
    checkedBy: string;


}